/** ISO 3166-1 alpha-2 countries for residence / passport nationality. */

export type ResidenceCountry = {
  code: string;
  ru: string;
  en: string;
};

/** Popular + CIS first, then A–Z by English name. */
export const RESIDENCE_COUNTRIES: ResidenceCountry[] = [
  { code: 'RU', ru: 'Россия', en: 'Russia' },
  { code: 'BY', ru: 'Беларусь', en: 'Belarus' },
  { code: 'KZ', ru: 'Казахстан', en: 'Kazakhstan' },
  { code: 'UA', ru: 'Украина', en: 'Ukraine' },
  { code: 'AM', ru: 'Армения', en: 'Armenia' },
  { code: 'GE', ru: 'Грузия', en: 'Georgia' },
  { code: 'UZ', ru: 'Узбекистан', en: 'Uzbekistan' },
  { code: 'KG', ru: 'Кыргызстан', en: 'Kyrgyzstan' },
  { code: 'TJ', ru: 'Таджикистан', en: 'Tajikistan' },
  { code: 'AZ', ru: 'Азербайджан', en: 'Azerbaijan' },
  { code: 'MD', ru: 'Молдова', en: 'Moldova' },
  { code: 'TM', ru: 'Туркменистан', en: 'Turkmenistan' },
  { code: 'US', ru: 'США', en: 'United States' },
  { code: 'GB', ru: 'Великобритания', en: 'United Kingdom' },
  { code: 'DE', ru: 'Германия', en: 'Germany' },
  { code: 'FR', ru: 'Франция', en: 'France' },
  { code: 'IT', ru: 'Италия', en: 'Italy' },
  { code: 'ES', ru: 'Испания', en: 'Spain' },
  { code: 'PT', ru: 'Португалия', en: 'Portugal' },
  { code: 'NL', ru: 'Нидерланды', en: 'Netherlands' },
  { code: 'BE', ru: 'Бельгия', en: 'Belgium' },
  { code: 'CH', ru: 'Швейцария', en: 'Switzerland' },
  { code: 'AT', ru: 'Австрия', en: 'Austria' },
  { code: 'PL', ru: 'Польша', en: 'Poland' },
  { code: 'CZ', ru: 'Чехия', en: 'Czechia' },
  { code: 'SK', ru: 'Словакия', en: 'Slovakia' },
  { code: 'HU', ru: 'Венгрия', en: 'Hungary' },
  { code: 'RO', ru: 'Румыния', en: 'Romania' },
  { code: 'BG', ru: 'Болгария', en: 'Bulgaria' },
  { code: 'GR', ru: 'Греция', en: 'Greece' },
  { code: 'TR', ru: 'Турция', en: 'Türkiye' },
  { code: 'IL', ru: 'Израиль', en: 'Israel' },
  { code: 'AE', ru: 'ОАЭ', en: 'United Arab Emirates' },
  { code: 'SA', ru: 'Саудовская Аравия', en: 'Saudi Arabia' },
  { code: 'QA', ru: 'Катар', en: 'Qatar' },
  { code: 'CN', ru: 'Китай', en: 'China' },
  { code: 'JP', ru: 'Япония', en: 'Japan' },
  { code: 'KR', ru: 'Южная Корея', en: 'South Korea' },
  { code: 'TW', ru: 'Тайвань', en: 'Taiwan' },
  { code: 'HK', ru: 'Гонконг', en: 'Hong Kong' },
  { code: 'TH', ru: 'Таиланд', en: 'Thailand' },
  { code: 'VN', ru: 'Вьетнам', en: 'Vietnam' },
  { code: 'ID', ru: 'Индонезия', en: 'Indonesia' },
  { code: 'MY', ru: 'Малайзия', en: 'Malaysia' },
  { code: 'SG', ru: 'Сингапур', en: 'Singapore' },
  { code: 'PH', ru: 'Филиппины', en: 'Philippines' },
  { code: 'IN', ru: 'Индия', en: 'India' },
  { code: 'AU', ru: 'Австралия', en: 'Australia' },
  { code: 'NZ', ru: 'Новая Зеландия', en: 'New Zealand' },
  { code: 'CA', ru: 'Канада', en: 'Canada' },
  { code: 'MX', ru: 'Мексика', en: 'Mexico' },
  { code: 'BR', ru: 'Бразилия', en: 'Brazil' },
  { code: 'AR', ru: 'Аргентина', en: 'Argentina' },
  { code: 'CL', ru: 'Чили', en: 'Chile' },
  { code: 'ZA', ru: 'ЮАР', en: 'South Africa' },
  { code: 'EG', ru: 'Египет', en: 'Egypt' },
  { code: 'MA', ru: 'Марокко', en: 'Morocco' },
  { code: 'RS', ru: 'Сербия', en: 'Serbia' },
  { code: 'HR', ru: 'Хорватия', en: 'Croatia' },
  { code: 'SI', ru: 'Словения', en: 'Slovenia' },
  { code: 'ME', ru: 'Черногория', en: 'Montenegro' },
  { code: 'BA', ru: 'Босния и Герцеговина', en: 'Bosnia and Herzegovina' },
  { code: 'MK', ru: 'Северная Македония', en: 'North Macedonia' },
  { code: 'AL', ru: 'Албания', en: 'Albania' },
  { code: 'FI', ru: 'Финляндия', en: 'Finland' },
  { code: 'SE', ru: 'Швеция', en: 'Sweden' },
  { code: 'NO', ru: 'Норвегия', en: 'Norway' },
  { code: 'DK', ru: 'Дания', en: 'Denmark' },
  { code: 'IE', ru: 'Ирландия', en: 'Ireland' },
  { code: 'EE', ru: 'Эстония', en: 'Estonia' },
  { code: 'LV', ru: 'Латвия', en: 'Latvia' },
  { code: 'LT', ru: 'Литва', en: 'Lithuania' },
  { code: 'CY', ru: 'Кипр', en: 'Cyprus' },
  { code: 'MT', ru: 'Мальта', en: 'Malta' },
];

export const DEFAULT_RESIDENCE_COUNTRY = 'RU';

export function countryLabel(code: string, lang: string): string {
  const c = RESIDENCE_COUNTRIES.find(x => x.code === code);
  if (!c) return code;
  return lang.toLowerCase().startsWith('ru') ? c.ru : c.en;
}

/** Alphabetical by localized name (ru → Cyrillic order, en → Latin). */
export function sortedResidenceCountries(lang: string): ResidenceCountry[] {
  const ru = lang.toLowerCase().startsWith('ru');
  const locale = ru ? 'ru' : 'en';
  return [...RESIDENCE_COUNTRIES].sort((a, b) =>
    (ru ? a.ru : a.en).localeCompare(ru ? b.ru : b.en, locale, { sensitivity: 'base' }),
  );
}

export function countryNameForPrompt(code: string): string {
  const c = RESIDENCE_COUNTRIES.find(x => x.code === code);
  if (!c) return code || 'Russia';
  return `${c.en} (${c.ru})`;
}
